/**
 *  StepAppDetection
 *
 *  The app detection.
 */

import React, { useState } from "react";
import { Image, Typography } from "antd";
import { useInterval } from "hooks";

import Status0 from "components/steps/StepAppDetection/App/status-0.bmp";
import Status1 from "components/steps/StepAppDetection/App/status-1.bmp";
import Status2 from "components/steps/StepAppDetection/App/status-2.bmp";
import Status3 from "components/steps/StepAppDetection/App/status-3.bmp";
import StatusDone from "components/steps/StepAppDetection/App/status-done.bmp";

const { Title } = Typography;
const interval = 2000; // The interval between image changes.

export const Running = () => {
  const [status, setStatus] = useState(0);

  useInterval(() => {
    if (status < 3) {
      setStatus(status + 1);
    }
  }, interval);

  var getStatusBmp = (status) => {
    if (status == 0) {
      return Status0;
    }
    if (status == 1) {
      return Status1;
    }
    if (status == 2) {
      return Status2;
    }
    if (status == 3) {
      return Status3;
    }
    return StatusDone;
  };

  // Render.
  return (
    <div className="text-center">
      <Title level={4}>Collecting system information...</Title>
      {/* <Image src={`/img/status-${status}.bmp`} /> */}
      <Image src={getStatusBmp(status)} />
    </div>
  );
};
